var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('HoraLocal',{attrs:{"title":' '}}),_c('Type',{attrs:{"dados":_vm.type},on:{"type":_vm.setType}}),_c('ListEventos',{attrs:{"params":_vm.type}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h2',[_vm._v("Eventos")])])
}]

export { render, staticRenderFns }